<template>
  <div class="article-list-warp">
    <!-- <van-nav-bar
      title="课堂"
      safe-area-inset-top
      fixed
      placeholder
      z-index="999"
    /> -->
    <!-- v-model="refreshing" 是否处于加载状态 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <!-- v-model是否处于加载状态，finished是否已加载完成 -->
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        finished-text="没有更多了"
        @load="load_more"
      >
        <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
        <div class="open-list" v-for="(item, index) in list" :key="index">
          <router-link
            style="color: #333"
            :to="{
              path: '/mls',
              query: { data:item}
            }"
          >
            <div class="list">
              <div class="list-title">
                <span class="title-icon"></span>
                <span class="title-txt">{{ item.title }}</span>
              </div>
              <div class="list-synopsis">
                <div class="synopsis-txt">
                  {{item.synopsis}}
                </div>
                <div class="createtime">
                  <span>{{item.time}}</span>&nbsp;&nbsp;&nbsp;
                  <span>{{item.author}}</span>
                </div>
                <div class="pic">
                  <img :src="item.contentPic" alt="">
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { NavBar, List, Cell, PullRefresh } from 'vant'
import ArticleList from '../../assets/js/articleList.js'
export default {
  components: {
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell
  },
  data() {
    return {
      articleList: ArticleList,
      list: [],
      refreshing: false,
      loading: false,
      error: false,
      finished: false,
      page: 0, // 页数
      limit: 10 // 条数
    }
  },
  methods: {
    load_more: function () {
      this.page += 1 // 页数+1
      this.onLoad()
    },
    onLoad() {
      let arr = this.getTableData(this.page, this.limit, this.articleList)
      this.list = this.list.concat(arr.data) // 追加数据
      // page：当前页   totalPage  总页数
      const size = parseInt(arr.length / this.limit) // 取商
      const rest = arr.length % this.limit // 取余数
      let totalPage
      if (rest > 0) {
        // 余数大于0，说明实际最后一页数据不足pageSize，应该取size+1为最后一条的页码
        totalPage = size + 1 // 当前页码重置，取size+1
      } else if (rest === 0) {
        // 余数等于0，最后一页数据条数正好是pageSize
        totalPage = size // 当前页码重置，取size
      }
      if (arr.page === totalPage) {
        // 数据全部加载完成
        this.finished = true
      } else {
        this.finished = false
      }
    },
    onRefresh() {
      // 清空列表数据
      this.list = []
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    /**
     * @name  getTableData
     * @desc  纯JS前端分页方法
     * @param  {Number} page 当前页码，默认1
     * @param  {Number} pageSize 每页最多显示条数，默认10
     * @param  {Array} totalData 总的数据集，默认为空数组
     * @return {Object} {
        data, //当前页展示数据，数组
        page, //当前页码
        pageSize, //每页最多显示条数
        length, //总的数据条数
      }
    **/
    getTableData(page, pageSize, totalData) {
      this.loading = false
      this.refreshing = false
      const { length } = totalData
      const tableData = {
        data: [],
        page,
        pageSize,
        length
      }
      if (pageSize >= length) {
        // pageSize大于等于总数据长度，说明只有1页数据或没有数据
        tableData.data = totalData
        tableData.page = 1 // 直接取第一页
      } else {
        // pageSize小于总数据长度，数据多余1页
        const num = pageSize * (page - 1) // 计算当前页（不含）之前的所有数据总条数
        if (num < length) {
          // 如果当前页之前所有数据总条数小于（不能等于）总的数据集长度，则说明当前页码没有超出最大页码
          const startIndex = num // 当前页第一条数据在总数据集中的索引
          const endIndex = num + pageSize - 1 // 当前页最后一条数据索引
          tableData.data = totalData.filter((_, index) => index >= startIndex && index <= endIndex) // 当前页数据条数小于每页最大条数时，也按最大条数范围筛取数据
        } else {
          // 当前页码超出最大页码，则计算实际最后一页的page，自动返回最后一页数据
          const size = parseInt(length / pageSize) // 取商
          const rest = length % pageSize // 取余数
          if (rest > 0) {
            // 余数大于0，说明实际最后一页数据不足pageSize，应该取size+1为最后一条的页码
            tableData.page = size + 1 // 当前页码重置，取size+1
            tableData.data = totalData.filter((_, index) => index >= pageSize * size && index <= length)
          } else if (rest === 0) {
            // 余数等于0，最后一页数据条数正好是pageSize
            tableData.page = size // 当前页码重置，取size
            tableData.data = totalData.filter((_, index) => index >= pageSize * (size - 1) && index <= length)
          } // 注：余数不可能小于0
        }
      }
      return tableData
    }
  }
}
</script>

<style lang="less">
.article-list-warp {
  // 返回按钮颜色
  .van-nav-bar__title {
    color: #FFFFFF;
  }
  // 背景色设置透明
  .van-nav-bar {
    background-color: transparent !important;
  }
  .van-hairline--bottom::after {
    border: 2px solid #2A2541;
  }
}
</style>
<style lang="less" scoped>
.article-list-warp{
  // background: url("../../assets/images/meetLover_bg.png");
  // background-repeat: no-repeat;
  // background-attachment:fixed;
  // background-size: cover;
  // color: #FFFFFF;

  .open-list {
    margin: 0 14px;
    padding: 5px;
    // border-radius: 5px;
    // box-shadow: 0px 0px 8px #cecece;
    .list{
      border-radius: 10px;
      padding: 15px 0;
      /*border-bottom: 0.1px solid #2A2541;*/
      border-bottom: 0.5px solid rgba(42, 37, 65, 0.4);
      background: #ffffff;
      /*background: #000000;*/
      .list-title{
        display: flex;
        flex-direction: row;
        .title-icon{
          display: inline-block;
          width: 24px;
          height: 22px;
          background-image:url('../../assets/images/title_icon.png');
          background-position:center center;
          background-repeat:no-repeat;
          background-size: cover;
          margin-right: 6px;
        }
        .title-txt{
          display: inline-block;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          // color: #FFFFFF;
          line-height: 22px;
          // 单行超出省略  start
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
          // 单行超出省略  end
        }
      }
      .list-synopsis{
        position: relative;
        .synopsis-txt{
          width: 60%;
          height: 34px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          // color: #FFFFFF;
          line-height: 17px;

          // 多行超出省略  start
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          // 多行超出省略  end
          margin-top: 14px;
        }
        .createtime{
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #CBCBCB;
          line-height: 14px;
          margin-top: 14px;
        }
        .pic{
          width: 95px;
          height: 70px;
          position: absolute;
          top: 0;
          right: 0;
          img{
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
        }
      }
    }
  }
}
</style>
